import '../application';
import 'sbf-design-system-component/donation-widget/donation_widget';
import '../widget/page_donate_widget_params';

$(function () {
  let slideShowingNum = 0;
  const $slides = $('.slide');
  let $slideShowing = $slides.eq(slideShowingNum);
  const maxSlidesNum = $slides.length;
  const $bubbles = $('.bubble');

  const $quotes = $('#quotes');
  const $previousSlideButton = $('#previous_slide');
  const $nextSlideButton = $('#next_slide');

  const $parallaxSection = $('#parallax');
  const $parallaxBg = $('#parallax_bg');
  const parallaxCoords = {};
  parallaxCoords.top = $parallaxSection.offset().top;
  parallaxCoords.bottom = parallaxCoords.top + $parallaxSection.height();
  parallaxCoords.start_point = parallaxCoords.top - document.documentElement.clientHeight;

  const parallaxRange = 450;
  const pixelsPerPoint = parallaxRange / (parallaxCoords.bottom - parallaxCoords.start_point);
  let parallaxTopValue;

  const $videoOverlay = $('#video_overlay');
  const $videoTrigger = $('#video_trigger');

  let youtubePlayer;

  checkParallax();

  $videoTrigger.click(function () {
    $('body').addClass('no-scroll');
    $videoOverlay.addClass('overlay-show');
    if (youtubePlayer !== undefined) {
      $('#video_container').html(youtubePlayer);
    }
  });

  $videoOverlay.click(function () {
    $('body').removeClass('no-scroll');
    $videoOverlay.removeClass('overlay-show');
    youtubePlayer = $videoOverlay.find('iframe').remove();
  });

  $previousSlideButton.click(function () {
    animateSlidesLeft();
  });

  $nextSlideButton.click(function () {
    animateSlidesRight();
  });

  $bubbles.click(function (e) {
    const index = $bubbles.index(this);

    if (index > slideShowingNum) {
      animateSlidesRight(index);
    }

    if (index < slideShowingNum) {
      animateSlidesLeft(index);
    }

    e.preventDefault();
  });

  animateSlide(0);

  function animateSlidesLeft (num) {
    if (slideShowingNum === maxSlidesNum - 1) {
      $nextSlideButton.removeClass('button-hide');
    }

    if (slideShowingNum >= 0) {
      const n = (num === undefined) ? slideShowingNum - 1 : num;
      $slideShowing.addClass('slide-hidden');

      animateSlide(n);

      $slideShowing.removeClass('slide-hidden');
      slideShowingNum = n;
      updateBubbles();
    }

    if (slideShowingNum === 0) {
      $previousSlideButton.addClass('button-hide');
    }
  }

  function animateSlidesRight (num) {
    if (slideShowingNum === 0) {
      $previousSlideButton.removeClass('button-hide');
    }

    if (slideShowingNum < maxSlidesNum - 1) {
      const n = num || slideShowingNum + 1;
      $slideShowing.addClass('slide-hidden');

      animateSlide(n);

      slideShowingNum = n;
      updateBubbles();
    }

    if (slideShowingNum === maxSlidesNum - 1) {
      $nextSlideButton.addClass('button-hide');
    }
  }

  function animateSlide (num) {
    $slideShowing = $slides.eq(num);
    const height = $slideShowing.height();

    $quotes.animate({
      height: height + 60
    }, 'slow');

    $slideShowing.removeClass('slide-hidden');
  }

  function getPagePos () {
    const pos = {};
    const doc = document.documentElement;
    pos.top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    pos.bottom = pos.top + document.documentElement.clientHeight;

    return pos;
  }

  function checkParallax () {
    const docPos = getPagePos();

    if (document.documentElement.clientWidth < 600) {
      return;
    }

    if (docPos.top > parallaxCoords.start_point && docPos.top < parallaxCoords.bottom) {
      const cssTop = Math.ceil((docPos.top - parallaxCoords.start_point) * pixelsPerPoint);
      if (parallaxTopValue !== cssTop) {
        parallaxTopValue = cssTop;
        $parallaxBg.css('top', cssTop * -1);
      }
    }
    window.requestAnimationFrame(checkParallax);
  }

  function updateBubbles () {
    $bubbles.removeClass('active');
    $bubbles.eq(slideShowingNum).addClass('active');
  }

  function debouncer (func, timeout = 200) {
    let timeoutID;
    return function () {
      const scope = this; const args = arguments;
      clearTimeout(timeoutID);
      timeoutID = setTimeout(function () {
        func.apply(scope, Array.prototype.slice.call(args));
      }, timeout);
    };
  }

  $(window).resize(debouncer(function (e) {
    const height = $slideShowing.height();

    $quotes.animate({
      height: height + 60
    }, 'slow');
  }));
});
